import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { SetSurvey } from "../../redux/slice/SurveySlice/SurveySlice";

export default function Card({ icons, title, description }) {
  const dispatch = useDispatch();
  const history = useHistory();
  return (
    <>
      <div
        onClick={() => (
          history.push("/createsurvey"),
          dispatch(
            SetSurvey({
              title: "Anket 1",
              description: "",
              questions: [],
            })
          )
        )}
        className="p-6 cursor-pointer m-6 max-w-sm bg-white rounded-lg border border-gray-200 shadow-md md:m-2 "
      >
        {icons}
        <div>
          <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 ">
            {title}
          </h5>
        </div>
        <p className="mb-3 font-normal text-gray-500 ">{description}</p>
      </div>
    </>
  );
}
